"use client";

import { ArrowUpRight, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Officelocationmap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const hours = [{
    day: "Monday",
    range: "09:00 — 18:00",
    isToday: false
  }, {
    day: "Tuesday",
    range: "09:00 — 18:00",
    isToday: false
  }, {
    day: "Wednesday",
    range: "09:00 — 18:00",
    isToday: true
  }, {
    day: "Thursday",
    range: "09:00 — 18:00",
    isToday: false
  }, {
    day: "Friday",
    range: "09:00 — 18:00",
    isToday: false
  }, {
    day: "Saturday",
    range: "10:00 — 14:00",
    isToday: false
  }, {
    day: "Sunday",
    range: "Closed",
    isToday: false
  }];
  return <section data-section-id="1586" id="officelocationmap" className="bg-background text-foreground py-0 relative overflow-hidden">
      <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 relative transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div aria-hidden="true" className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-border z-10" />

        {}
        <div className="lg:col-span-6 relative order-2 lg:order-1 min-h-[420px] lg:min-h-[680px] bg-primary border-t border-border lg:border-t-0">
          {}
          <div className="absolute top-8 left-8 lg:top-10 lg:left-10 z-20 font-mono text-xs tracking-[0.16em] uppercase">
            <span className="text-secondary">§</span>
            <span className="text-muted-foreground"> 07 · /visit/22.8905°N,-109.9167°W</span>
          </div>

          {}
          <div className="absolute inset-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/cabo_office_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/cabo_office_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/cabo_office_map.png-wvc-sizes" alt="Map of IMI Elite Management office location in Los Cabos" loading="lazy" decoding="async" className="w-full h-full object-cover opacity-90" src="https://imielite.com/wp-content/uploads/2026/06/map_mercabo_repositioned.png" />
            {}
            <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
            background: "radial-gradient(40vw 40vw at 55% 45%, hsl(204 80% 60% / 0.12), transparent 70%)"
          }} />

            {}
            <div className="absolute left-[55%] top-[calc(45%+2in)] -translate-x-1/2 -translate-y-1/2 z-20">
              <div className="relative">
                <span aria-hidden="true" className="absolute inset-0 rounded-lg animate-ping" style={{
                backgroundColor: "hsl(204 80% 60% / 0.5)",
                width: "32px",
                height: "32px",
                left: "-16px",
                top: "-16px"
              }} />
                <div className="relative w-4 h-4 rounded-lg border-2 border-background" style={{
                backgroundColor: "hsl(204 80% 60%)"
              }} />
              </div>
            </div>
          </div>

          {}
          <div className="absolute bottom-6 left-6 lg:bottom-10 lg:left-10 z-20 bg-card border border-border rounded-lg p-5 max-w-[280px] shadow-lg">
            <div className="flex items-start justify-between gap-4">
              <div>
                <p className="font-default text-xs tracking-[0.16em] uppercase text-foreground font-medium">
                  LOS CABOS · MEXICO
                </p>
                <p className="font-mono text-[11px] tracking-[0.12em] uppercase text-muted-foreground mt-1.5">
                  22.8905°N · -109.9167°W
                </p>
              </div>
              <div className="w-2 h-2 rounded-lg mt-1 shrink-0" style={{
              backgroundColor: "hsl(204 80% 60%)"
            }} />
            </div>
            <Link to="https://maps.google.com/?q=Av.+Quintas+California+Mz+2+Lot+11,+Fracc+Quintas+California,+Los+Cabos" newTab className="mt-4 inline-flex items-center gap-1.5 font-default text-xs tracking-[0.08em] uppercase text-foreground hover:text-secondary transition-colors duration-200 group">
              <span className="underline underline-offset-[6px] decoration-border group-hover:decoration-secondary">
                Open in Maps
              </span>
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
            </Link>

            {}
            <span aria-hidden="true" className="absolute top-0 left-0 w-3 h-3 border-t border-l border-muted-foreground" />
            <span aria-hidden="true" className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-muted-foreground" />
          </div>
        </div>

        {}
        <div className="lg:col-span-6 bg-card px-6 sm:px-10 md:px-16 py-20 md:py-24 relative order-1 lg:order-2">
          {}
          <div aria-hidden="true" className="absolute -top-20 -right-20 w-[60vw] max-w-[640px] h-[640px] pointer-events-none" style={{
          background: "radial-gradient(closest-side, hsl(204 80% 60% / 0.14), transparent 70%)"
        }} />

          <div className="relative">
            {}
            <div className="lg:hidden font-mono text-xs tracking-[0.16em] uppercase mb-10">
              <span className="text-secondary">§</span>
              <span className="text-muted-foreground"> 07 · /visit</span>
            </div>

            {}
            <h2 className="font-default font-medium text-foreground tracking-tight leading-[1.0] text-[clamp(2rem,5vw,4.25rem)]">
              Visit our{" "}
              <span className="inline-block border border-secondary rounded-lg px-[6px] align-baseline">
                office
              </span>
            </h2>

            <p className="mt-6 text-muted-foreground text-base md:text-lg max-w-md leading-[1.55]">Located in the heart of Los Cabos, inside Mercabo. Schedule a consultation with our management team to discuss your property or exit strategy.</p>

            {}
            <div className="mt-12">
              <div className="flex items-center justify-between mb-5">
                <span className="font-mono text-xs tracking-[0.16em] uppercase text-muted-foreground">
                  /hours
                </span>
                <Separator />
              </div>

              <ul className="flex flex-col">
                {hours.map((item, i) => <li data-index={i} key={item.day} className={`relative grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_auto_auto] items-center gap-4 py-3 border-b border-border last:border-b-0 ${item.isToday ? "pl-4" : "pl-4"}`}>
                    {item.isToday && <span aria-hidden="true" className="absolute left-0 top-2 bottom-2 w-[4px] rounded-lg" style={{
                  backgroundColor: "hsl(204 80% 60%)"
                }} />}
                    <span className={`font-default text-sm tracking-[0.04em] ${item.isToday ? "text-foreground font-medium" : "text-muted-foreground"}`}>
                      {item.day}
                    </span>
                    <span className={`font-mono text-sm tracking-[0.04em] tabular-nums ${item.isToday ? "text-foreground" : "text-muted-foreground"}`}>
                      {item.range}
                    </span>
                    {item.isToday && <span className="hidden sm:inline-flex font-mono text-[10px] tracking-[0.12em] uppercase px-2 py-1 rounded-lg border border-secondary text-secondary">
                        Open Now
                      </span>}
                  </li>)}
              </ul>
            </div>

            {}
            <div className="mt-12">
              <div className="flex items-center justify-between mb-5">
                <span className="font-mono text-xs tracking-[0.16em] uppercase text-muted-foreground">
                  /address
                </span>
                <Separator />
              </div>

              <address className="not-italic flex flex-col gap-2.5 font-default text-sm tracking-[0.02em]">
                <Link to="https://maps.google.com/?q=Av.+Quintas+California+Mz+2+Lot+11,+Fracc+Quintas+California,+Los+Cabos" newTab className="text-foreground hover:text-secondary transition-colors duration-200 underline underline-offset-[6px] decoration-border hover:decoration-secondary w-fit inline-flex items-center gap-2">
                  Ignacio Zaragoza, Downtown, Ildefonso Green, 23470<br />Cabo San Lucas, B.C.S.
                </Link>
                <Link to="tel:+526241647031" className="text-foreground hover:text-secondary transition-colors duration-200 underline underline-offset-[6px] decoration-border hover:decoration-secondary w-fit inline-flex items-center gap-2">
                  <Phone className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
                  +52 624 164 7031
                </Link>
              </address>
            </div>

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4">
              <Button asChild className="bg-primary hover:bg-primary/90 text-white rounded-lg px-7 py-3.5 h-auto font-default font-medium tracking-tight transition-shadow duration-300">
                <Link to="https://maps.google.com/?q=Av.+Quintas+California+Mz+2+Lot+11,+Fracc+Quintas+California,+Los+Cabos" newTab>
                  Get Directions
                </Link>
              </Button>
              <Button asChild variant="outline" className="bg-transparent border border-foreground text-foreground hover:bg-transparent hover:text-secondary hover:border-secondary rounded-lg px-7 py-3.5 h-auto font-default font-medium tracking-tight transition-colors duration-200">
                <Link to="#">Contact Us</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="relative h-px w-full bg-border">
        <span aria-hidden="true" className="absolute left-0 top-0 h-px w-24" style={{
        backgroundColor: "hsl(204 80% 60%)"
      }} />
      </div>
    </section>;
}
function Separator() {
  return <span aria-hidden="true" className="flex-1 ml-4 h-px bg-border" />;
}